(function ($) {
    'use strict';
    $(document).ready(function () {
        $("#csl_content_email_reset").click(function () {
            var dataReset = $(this).data('reset');
            var type = $("#csl_content_email_type").val();

            if (!dataReset[type]) {
                dataReset[type] = {
                    subject: '',
                    content: ''
                };
            }

            $("#csl_content_email_subject").val(dataReset[type].subject);
            $("#csl_content_email_content").val(dataReset[type].content);

            if (CKEDITOR.instances['csl_content_email_content']) {
                CKEDITOR.instances['csl_content_email_content'].setData(dataReset[type].content);
            }
        });

        $("#csl_content_email_type").change(function () {
            $("#csl_content_email_reset").click();
        });

        return false;
    });
})(jQuery);
